<template>
  <div>
    <div v-if="value">
      <img height="16" src="/assets/images/telegram.png" alt="" />
    </div>
    <div v-else>
      <i class="fas fa-times default-null-html"></i>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    }
  }
}
</script>
